<template>
  <div class="nuttrema-index-virtual-group-list">

    <nuttrema-loader v-if="state.fetching"></nuttrema-loader>

    <template v-else>
      <div class="nuttrema-index-virtual-group-list__header">
        <nuttrema-group-and-sort-virtual
          :grouping="grouping" :sorting="sorting" :orders="orders"
          @changeGroupBy="onChangeGroupBy"
          @changeSortBy="onChangeSortBy"
          @changeOrder="onChangeOrder">
        </nuttrema-group-and-sort-virtual>
      </div>

      <div class="nuttrema-index-virtual-group-list__content">
        <div class="nuttrema-index-virtual-group-list__content__list">
          <nuttrema-empty-result
            v-if="_isEmpty(state.data) && _isEmpty(state)"
            slot="central"
            class="with-logo"
            icon="far fa-battery-slash">
            <template slot="text">
              <h1 v-html="$t('label.list_is_empty')"></h1>
              <h4 v-html="$t('label.create_first_item')"></h4>
            </template>
          </nuttrema-empty-result>

          <nuttrema-index-list-item
             v-else
             v-for="(group, key) in list"
            :group="group"
            :title="getTitle(key)"
            :key="key"
            :features="features"
            :meta="meta">
          </nuttrema-index-list-item>

          <div class="nuttrema-index-virtual-group-list__content__note">
            <p class="note__title">{{ $t('label.included_in_you_subscription_plan') }}:</p>
            <ul>
              <template v-for="(data, feature) in features">
                <li
                  v-if="data.subscribed"
                  v-html="_markdown.renderInline($t('label.feature_source_note', { feature: $t(`label.${feature}`), upper_limit: data.upper_limit, used_count: data.used_count }))">
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { orderBy, assign, first } from 'lodash';

import NuttremaIndexVirtualGroupList from 'components/ui/list/nuttrema-index-virtual-group-list';
import NuttremaIndexListItem from './cmpt-instance-sources-list-item';

export default {
  mixins: [NuttremaIndexVirtualGroupList],
  name: 'cmpt-instance-sources-list',
  components: {
    NuttremaIndexListItem,
  },
  props: {
    features: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    monitored() {
      return this.state;
    },
  },
  methods: {
    order() {
      switch (this.sorting.selected.key) {
        case 'status':
          return orderBy(this.state, [item => item.active], [this.orders.selected]);
        case 'name':
          return orderBy(this.state, [item => item.name], [this.orders.selected]);
        default:
          return orderBy(this.state, [item => new Date(item.name)], [this.orders.selected]);
      }
    },
  },
  created() {
    const groupingList = [
      { label: 'label.region', type: 'property', key: 'country' },
      { label: 'label.source_type', type: 'property', key: 'SourceType.code' },
    ];
    const sortingList = [
      { label: 'label.name', key: 'name' },
      { label: 'label.status', key: 'status' },
    ];
    assign(this.grouping, {
      list: groupingList,
      selected: first(groupingList),
    });
    assign(this.sorting, {
      list: sortingList,
      selected: first(sortingList),
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/sources/list/cmpt-instance-sources-list.vue